<script setup lang="ts">
import { faRefresh } from '@fortawesome/pro-regular-svg-icons/faRefresh';

const { label = 'متن تصویر زیر', fetcher } = defineProps<{
    label?: string;
    fetcher: () => Promise<{ image: string; text: string; token: string }>;
}>();

const src = ref('');
const input = defineModel<string>('input', { default: '' });
const text = defineModel<string>('text', { default: '' });
const token = defineModel<string>('token', { default: '' });
const invalid = defineModel<boolean>('invalid');
const loading = ref(false);
async function loadCaptcha(): Promise<void> {
    loading.value = true;
    try {
        const data = await fetcher();
        src.value = data.image ?? '';
        text.value = data.text ?? '';
        token.value = data.token ?? '';
    } catch (e) {
        reportException(e);
    } finally {
        loading.value = false;
    }
}
onMounted(() => loadCaptcha());
defineExpose({ loadCaptcha });
</script>
<template>
    <div class="captcha-input-container">
        <mr-input
            v-model="input"
            required
            :label
            hide-description
            :invalid
            @update:model-value="invalid = false"
        />
        <img :src alt="captcha" />
        <mr-button :icon-button="faRefresh" :loading @click="loadCaptcha" />
    </div>
</template>
<style scoped lang="scss">
.captcha-input-container {
    display: flex;
    gap: 16px;
    align-items: flex-end;
    img {
        width: auto;
        height: 48px;
    }
}
</style>
